import React from "react";
import { SWTypes } from "interfaces/sw/SWInterfaces";
import "./SWTypeIconAI.scoped.scss";


const SWTypeIconAI = () => {
    let labelText = "TLM"

    return (
        <div className="hexagon">
            <div className="content">
                <div className="paper">
                    <svg width={14} height={12} viewBox="0 0 14 12">
                        <path d="M 0 2 Q 0 0 2 0 H 11 L 14 3 V 12 H 0 Z" fill="white" />
                        <rect rx={1} ry={1} x="2" y="2" width={9} height={1.5} fill="#0D5EB6" />
                        <rect rx={1} ry={1} x="2" y="5" width={10} height={1.5} fill="#0D5EB6" />
                        <rect rx={1} ry={1} x="2" y="8" width={10} height={1.5} fill="#0D5EB6" />
                    </svg>
                </div>

                <label className="legend top">AI</label>
                <label className="legend bottom">{labelText}</label>
            </div>

        </div>);
}

export default SWTypeIconAI;